import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CaptchaContainer from 'components/Captcha/containers/CaptchaContainer';
import ReCAPTCHA from 'react-google-recaptcha';

class ReCaptcha extends Component {
  constructor(props) {
    super(props);

    this.captchaRef = React.createRef();

    this.state = {
      reCaptchaResponse: null
    };

    // Если нужно проверять неуспешные валидации то обновляем данные неуспешных валидаций
    if (this.props.isCheckFailValidCounterFull) {
      this.props.setOnlyFailValidCounter();
      this.props.sendRequestGetCaptcha();
    }
  }

  componentWillUpdate(nextProps) {
    // Сбрасываем капчу если форма не прошла валидацию, тк response одноразовый
    if (
      nextProps.requestStateOfForm.hasSuccessQuery !==
        this.props.requestStateOfForm.hasSuccessQuery &&
      nextProps.requestStateOfForm.hasSuccessQuery === false &&
      this.state.reCaptchaResponse
    ) {
      // Сброс капчи https://developers.google.com/recaptcha/docs/display#js_api
      this.captchaRef.current.reset();
    }
  }

  handleChangeValue = value => {
    this.setState({
      reCaptchaResponse: value
    });
    this.props.changeCaptchaValue(value);
  };

  render() {
    if (
      this.props.isCheckFailValidCounterFull &&
      !this.props.data.isFailValidCounterFull
    ) {
      return null;
    }
    return (
      <ReCAPTCHA
        style={{
          margin: '0 auto',
          width: '304px',
          paddingBottom: '10px'
        }}
        ref={this.captchaRef}
        onChange={this.handleChangeValue}
        // eslint-disable-next-line dot-notation
        sitekey={process.env['RECAPTCHA_SITE_KEY']}
      />
    );
  }
}

ReCaptcha.defaultProps = {
  isCheckFailValidCounterFull: false
};

ReCaptcha.propTypes = {
  // IN
  isCheckFailValidCounterFull: PropTypes.bool,
  requestStateOfForm: PropTypes.shape({
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  changeCaptchaValue: PropTypes.func.isRequired,
  // CONNECT
  setOnlyFailValidCounter: PropTypes.func.isRequired,
  sendRequestGetCaptcha: PropTypes.func.isRequired,
  data: PropTypes.shape({
    answer: PropTypes.arrayOf(PropTypes.string),
    isFailValidCounterFull: PropTypes.bool,
    imageBase64: PropTypes.string
  }).isRequired
};

export default CaptchaContainer(ReCaptcha);



// WEBPACK FOOTER //
// ./src/components/Captcha/ReCaptcha/ReCaptcha.js